import React, { useState, useEffect } from "react";
import { CircularProgress, Grid, Stack } from "@mui/material";
import UserRow from "src/components/Layout/UserRow";
import localforage from "localforage";
import { connect } from "react-redux";
import { insert } from "src/pages/admin/settingV3/helpers";
import { useLocation, useNavigate } from "react-router";
import "src/App.css";
import { version } from "src/configs/globalVariable";

const Index = ({ heightHeader }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState("container");
  const navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    checkUrl();
    fetchData();
  }, []);

  const checkUrl = () => {
    const path = window.location.pathname.split("/");
    if (path[4] !== "detail" || !state.job_posting_id) {
      navigate(`/${version}/user/`);
      return;
    }
  };

  const fetchData = async () => {
    const resTempData = await localforage.getItem("tempData");
    const num = heightHeader?.split("rem")[0];
    tempDataContent.sectProps.pt = num * 3 + "rem";
    tempDataContent.sectProps.pb = num * 2 + "rem";
    const tempData = insert(resTempData, 1, tempDataContent);
    setData(tempData);
    setLoading(false);
  };

  const renderRow = (row) => {
    return <UserRow key={row.id} data={row} />;
  };

  if (loading === "container")
    return (
      <Stack>
        <CircularProgress sx={{ m: "auto" }} />
      </Stack>
    );

  return (
    <Grid
      component="main"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#F6F8FD",
      }}
    >
      {data
        .filter((v) => v.visibility)
        .map((row) => {
          return <React.Fragment key={row.id}>{renderRow(row)}</React.Fragment>;
        })}
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  heightHeader: state.preview.heightHeader,
});

export default connect(mapStateToProps)(Index);

const tempDataContent = {
  id: "CNpjR70Er",
  type: "row",
  props: {
    maxWidth: "80%",
  },
  children: [
    {
      id: "31ZVfDnAV",
      type: "column",
      props: {},
      children: [
        {
          id: "Wa2MSTlSv",
          type: "element",
          variant: "element51", // detail vacancy => shortcut : component in list elements library.js
        },
      ],
      colWidth: 12,
    },
  ],
  sectProps: {},
  visibility: true,
};
